<template>
  <footer class="footer">
    <p>{{$t('login.forgot.copyrightText')}} </p>
    <p><span>{{$t('login.forgot.icpText')}}</span><span class="marginL">{{$t('login.forgot.policeRecordText')}}</span> <router-link style="cursor:pointer;color:#BEBEC8!important;" target="_blank" :to="{path: '/privacyPolicy'}">{{$t('login.forgot.privacyPolicyText')}}</router-link></p>
  </footer>
</template>

<script>
export default {
  name: '',
  data() {
    return {}
  },
  components: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang='scss' scoped>
.marginL {
  margin-left: 20px;
}
</style>
